import React from 'react';
import {Box, keyframes} from '@mui/material';

const bounceAnimation = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1.0); }
`;

const Spinner = (color: any) => {
  const spinnerBackground =
    color == 'transparent'
      ? {backgroundColor: '#e9630c'}
      : {backgroundColor: '#FFF'};

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        display: 'flex',
        gap: '5px',
      }}
    >
      {[0, 1, 2].map(i => (
        <Box
          key={i}
          sx={{
            width: '13px',
            height: '13px',
            borderRadius: '100%',
            display: 'inline-block',
            animation: `${bounceAnimation} 1.4s infinite ease-in-out both`,
            animationDelay: `${-0.16 * (2 - i)}s`,
            ...spinnerBackground,
          }}
        />
      ))}
    </Box>
  );
};

export default Spinner;
